export const getNotificationSettings = (brandName) => [
  {
    setting: `${brandName} Monthly Download Reminder`,
    topic: 'weeklyDataUpdates',
    text: "Receive monthly email reminders to download your institution's data.",
  },
];
